<template>
<div class="tab-container">
  <van-tabs type="card">
    <van-tab :title="'好友(' + friend_cnt[0] + ')'">
      <van-list
        v-model="loading[0]"
        :finished="finished[0]"
        @load="onLoad(0)"
      >
        <van-card
          v-for="item in list[0]"
          :key="item.uid"
          :tag="'LV' + item.level"
          :thumb="item.headurl"
          centered
        >
          <h2 slot="title" class="van-ellipsis">{{item.nickname}}</h2>
          <div slot="tags">{{item.subscribe_time}} 加入</div>
        </van-card>
      </van-list>
    </van-tab>
    <van-tab :title="'潜在好友(' + friend_cnt[1] + ')'">
      <van-list
        v-model="loading[1]"
        :finished="finished[1]"
        @load="onLoad(1)"
      >
        <van-card
          v-for="item in list[1]"
          :key="item.uid"
          :tag="'LV' + item.level"
          :thumb="item.headurl"
          centered
        >
          <h2 slot="title" class="van-ellipsis">{{item.nickname}}</h2>
          <div slot="tags">{{item.subscribe_time}} 来过</div>
        </van-card>
      </van-list>
    </van-tab>
  </van-tabs>
</div>
</template>

<script>
import { Tag, Tab, Tabs, Cell, List, Card } from "vant";

export default {
  components: {
    [Tag.name]: Tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Cell.name]: Cell,
    [List.name]: List,
    [Card.name]: Card
  },
  data() {
    return {
      list: [[], []],
      loading: [false, false],
      finished: [false, false],
      friend_cnt: ["-", "-"],
      pn: [0, 0],
      ps: 8
    };
  },
  methods: {
    loadFriends(openid, type) {
      this.$http
        .get("https://cb.xhare.cn/friends", {
          params: { openid: openid, pn: this.pn[type], ps: this.ps, type: type }
        })
        .then(
          function(res) {
            if (res.data.code == 0) {
              if (type == 0 && this.pn[type] == 0) {
                this.friend_cnt[0] = "" + res.data.count[0];
                this.friend_cnt[1] = "" + res.data.count[1];
                if (res.data.count[1] == 0) {
                  this.loading[1] = false;
                  this.finished[1] = true;
                }
              }
              if (res.data.data.length > 0) {
                res.data.data.forEach(element => {
                  this.list[type].push({
                    uid: element.uid,
                    headurl: element.portrait,
                    nickname: element.nickname,
                    level: element.level,
                    subscribe_time: element.subscribe_time
                  });
                });
              }

              this.loading[type] = false;
              if (res.data.data.length < this.ps) {
                this.finished[type] = true;
              }
            }
            this.pn[type]++;
          }.bind(this)
        )
        .catch(
          function() {
            this.redirect();
          }.bind(this)
        );
    },
    redirect() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1939c838a577589a&redirect_uri=https://m.xhare.cn/i/%23team&response_type=code&scope=snsapi_base&state=ucenter";
    },
    onLoad(type) {
      let openid = sessionStorage.getItem("openid");
      if (openid) {
        this.loadFriends(openid, type);
      } else {
        this.$http
          .get("https://cb.xhare.cn/openid", {
            params: {
              code: (window.location.search
                .substr(1)
                .match(/(^|&)code=([^&]*)(&|$)/i) || [])[2]
            }
          })
          .then(
            function(res) {
              if (res.data.openid == "") {
                this.redirect();
              } else {
                this.loadFriends(res.data.openid, type);
                sessionStorage.setItem("openid", res.data.openid);
              }
            }.bind(this)
          )
          .catch(
            function() {
              this.redirect();
            }.bind(this)
          );
      }
    }
  }
};
</script>

<style lang="less">
</style>
